import { referencesAjax } from '../ajax/ReferencesAjax'
import { ErrorResponse } from '../DTOs/Common/ErrorResponse'
import { ShiftDTO } from '../DTOs/ShiftDTO'
import { setLatestShift } from '../state/reducers/shiftReducer'
import { store } from '../state/store'
import { isOnlineNow } from './connectivity'
import { shiftLetterToName } from "../types/Shift";

export async function refreshLatestShift(): Promise<void> {
  if (!isOnlineNow()) return

  try {
    const raw = await referencesAjax.getLatestShift()
    if (raw instanceof ErrorResponse || !ShiftDTO.is(raw) || !raw.dayOrNight) return

    const date = typeof raw.date === 'string' ? raw.date : raw.date?.toISODate() ?? null
    if (!date) return

    store.dispatch(setLatestShift({ date, shift: shiftLetterToName(raw.dayOrNight) }))
  } catch {
    // ignore - offline, cancelled or a server error; the marker keeps its previous value
  }
}
